// extracted by mini-css-extract-plugin
export default {"process_img":"Process_process_img__aTQ1g"};